import React, { useCallback } from 'react';

import {
  Flex, FlexProps, Modal, ModalContent, ModalOverlay, Spinner, useToast,
} from '@chakra-ui/react';

import NavBar from 'containers/Navbar';
import Sidebar from 'containers/Sidebar';

interface PageProps extends FlexProps{
  colStart?:number
  colEnd?: number
  isLoading?: boolean
  isCentered?: boolean
}

export default function Page({
  children,
  bg = 'gray.50',
  isLoading = false,
  isCentered = false,
  ...rest
}: PageProps) {
  const Wrapper = useCallback((props) => {
    if (isCentered) {
      return (
        <Flex
          maxW="1024px"
          mx="auto"
          w="100%"
          pr={5}
          py={6}
          pl={10}
          flexDirection="column"
          {...props}
        />
      );
    }
    return <React.Fragment {...props} />;
  }, [isCentered]);
  const toast = useToast();
  return (
    <Flex>
      <Sidebar />
      <Modal
        isOpen={isLoading}
        onClose={() => {
          toast({
            title: 'Aguarde um momento.',
            description: 'Estamos carregando as informações',
            status: 'info',
            duration: 2000,
            position: 'top-right',
            isClosable: true,
          });
        }}>
        <ModalOverlay />
        <ModalContent
          alignSelf="center"
          bg="transparent"
          alignItems="center"
          shadow="none">
          <Spinner
            color="primary.default"
            thickness="4px"
            size="xl"
          />
        </ModalContent>
      </Modal>
      <Flex
        w="100%"
        minH="100%"
        flexDir="column"
        bg={bg}>
        <NavBar />
        <Flex
          flexDir="column"
          w="100%"
          h="100%"
          p={6}
          {...rest}>
          <Wrapper>
            {children}
          </Wrapper>
        </Flex>
      </Flex>
    </Flex>
  );
}
